const filterReconFields = [
    {
        name: 'match_id',
        label: 'Match Id',
        type: 'String'
    },
    {
        name: 'comments',
        label: 'Comments',
        type: 'String'
    },
    {
        name: 'label',
        label: 'Label',
        type: 'String'
    },
    {
        name: 'match_status',
        label: 'Match Status',
        type: 'String'
    },
    {
        name: 'created_date',
        label: 'Created Date',
        type: 'Date'
    },
    {
        name: 'last_modified_date',
        label: 'Last Modified Date',
        type: 'Date'
    },
    {
        name: 'last_modified_by',
        label: 'Last Modified By',
        type: 'String'
    },
];

export default filterReconFields;